// © Microsoft Corporation. All rights reserved.
export default class AccessibilityHelpers {
    static style: HTMLStyleElement;

    static attachAccessibilityListeners = (document: Document, node?: HTMLElement) => {

        if (!node) {
            Array.from(document.getElementsByClassName("cwt-sort-list-item")).map(AccessibilityHelpers.addTabIndex);
            Array.from(document.getElementsByClassName("cwt-link")).map(AccessibilityHelpers.addTabIndex);
            Array.from(document.getElementsByClassName("cwt-access-li")).map(AccessibilityHelpers.addTabIndex);
            Array.from(document.getElementsByClassName("cwt-button")).map(AccessibilityHelpers.addTabIndex);
            Array.from(document.getElementsByTagName("a")).map((AccessibilityHelpers.addTabIndex));
        } else {
            Array.from(node.getElementsByClassName("cwt-sort-list-item")).map(AccessibilityHelpers.addTabIndex);
            Array.from(node.getElementsByClassName("cwt-link")).map(AccessibilityHelpers.addTabIndex);
            Array.from(node.getElementsByClassName("cwt-access-li")).map(AccessibilityHelpers.addTabIndex);
            Array.from(node.getElementsByClassName("cwt-button")).map(AccessibilityHelpers.addTabIndex);
            Array.from(node.getElementsByClassName("cwt-privacy-checkbox")).map(AccessibilityHelpers.addTabIndex);
            Array.from(node.getElementsByTagName("a")).map((AccessibilityHelpers.addTabIndex));
        }

        !AccessibilityHelpers.style && AccessibilityHelpers.addAccessibilityOutlines();
    };

    private static simulateMouseClick = (targetNode) => {
        if (targetNode) {
            // --- Simulate a natural mouse-click sequence.
            triggerMouseEvent(targetNode, "mousedown");
            triggerMouseEvent(targetNode, "click");
        }

        function triggerMouseEvent(node, eventType) {
            const clickEvent = document.createEvent("MouseEvents");
            clickEvent.initEvent(eventType, true, true);
            node.dispatchEvent(clickEvent);
        }
    };

    private static addTabIndex = (ele) => {
        if ((ele as HTMLElement).getAttribute("no-access") == "true") {
            return null;
        }

        // Add tab-index
        !ele.hasAttribute("tabIndex") && ele.setAttribute("tabIndex", "0");

        // Add Enter key listener to fire click event
        if (!ele.hasAttribute("hasEnterKeydown")) {
            ele.setAttribute("hasEnterKeydown", "1");
            ele.addEventListener("keydown", (e) => {
                if (e.keyCode === 13) {  // checks whether the pressed key is "Enter"
                    AccessibilityHelpers.simulateMouseClick(ele);
                    e.preventDefault();
                    e.stopPropagation();
                }
            });
        }
    };

    private static addAccessibilityOutlines = () => {
        let shouldHaveOutline = false;
        const focusKeys  = [9, 37, 38, 39, 40];

        AccessibilityHelpers.style = document.createElement("style");
        const targetNode = document.head;
        targetNode.append(AccessibilityHelpers.style);

        document.addEventListener("keydown", (e) => {
            if (focusKeys.includes(e.keyCode) && !shouldHaveOutline) {
                shouldHaveOutline = true;
            }
        });
        document.addEventListener("mousedown", (e) => {
            if (e.isTrusted) {
                shouldHaveOutline = false;
            }
        });
        document.addEventListener("focusin", (e) => {
            if (!shouldHaveOutline && e.isTrusted) {
                AccessibilityHelpers.style.innerText = "[hasEnterKeydown]:focus { outline: none; }";
            } else {
                if (AccessibilityHelpers.style) {
                    AccessibilityHelpers.style.innerText = "[hasEnterKeydown]:focus {  outline: \"black auto 1px\";}";
                }
            }
        });
    };
}
